// Fehlergrenze je Modulroute (UX G3): der Fehler bleibt auf das Modul begrenzt, die Shell bleibt bedienbar.
import { useEffect, useState } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router';

export function RouteError({ module }: { module?: string }) {
  const error = useRouteError();
  const [errorId] = useState(() => crypto.randomUUID().slice(0, 8));
  useEffect(() => {
    if (!isRouteErrorResponse(error)) console.error(`[route] ${module ?? 'app'} ${errorId}`, error);
  }, [error, errorId, module]);
  return (
    <section role="alert" data-ready="true" className="rounded-xl bg-card p-6">
      <h1 className="text-title-detail text-fg">Something went wrong on this page.</h1>
      <p className="mt-2 text-label text-fg-secondary">
        Error ID <code className="font-mono">{errorId}</code>
        {module ? ` · ${module}` : ''}
      </p>
      <div className="mt-4 flex gap-2">
        <button
          type="button"
          className="h-control rounded-full bg-primary px-4 text-button text-on-primary"
          onClick={() => window.location.reload()}
        >
          Reload
        </button>
        <a
          className="inline-flex h-control items-center rounded-full bg-pill-card px-4 text-button text-fg"
          href="/"
        >
          Go home
        </a>
      </div>
    </section>
  );
}
